module.exports = __webpack_public_path__ + "img/dataPark4.e8f5ee0f.png";